import React from "react";
import { ContentRedux } from "./Content";
import cname from "../style.module.scss";

import {
  FullscreenModal,
  CloseButton,
} from "@learningblocks/storybook-components/lib/FullscreenModal";

/**
 * Props for the PrincipleOfSpectrophotometerModal component
 */
interface MicroplateReaderFocusModalProps {
  /**
   * Whether the modal window is open
   */
  isOpen: boolean;
  /**
   * Function to call when closing the modal window
   */
  onClose: () => void;
  /**
   * Whether the notebook is collapsed
   */
  notebookCollapsed: boolean;
}

/**
 * PrincipleOfSpectrophotometerModal:
 *  - Give user general info on Spectrophotometer and
 *    its working
 */
export function MicroplateReaderFocusModal(
  props: MicroplateReaderFocusModalProps
) {
  return (
    <FullscreenModal
      isOpen={props.isOpen}
      className={`${cname.microplateReaderFocusModal}`}
      notebookExpanded={!props.notebookCollapsed}
      close={props.onClose}
    >
      <div className={cname.backButton}>
        <CloseButton close={props.onClose} backLabel="Lab" />
      </div>
      <div className={cname.container}>
        <div className={cname.section}>
          <ContentRedux />
        </div>
      </div>
    </FullscreenModal>
  );
}
